import React from 'react'
import { useState, useEffect } from 'react'
import { Routes, Route, NavLink, useNavigate, useLocation, json } from 'react-router-dom'

import Claims from '../pages/DeniedClaims'
import PendingClaims from '../pages/PendingClaims'
import RejectedClaims from '../pages/RejectedClaims'
import DeniedClaims from '../pages/DeniedClaims'
import ExpiringClaims from '../pages/ExpiringClaims'
import ErrorClaims from '../pages/ErrorClaims'
import ClosedClaims from '../pages/ClosedClaims'
import SubmissionClaims from '../pages/SubmissonClaims'
import { useDispatch, useSelector } from 'react-redux';
import { APIConstants, CommonAPIConstants } from '../utilities/Constants'



const TabNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState('');
  const [claimCountData, setclaimCountData] = useState('');

  const dispatch = useDispatch();


  const userData = useSelector((state) => state.user.user);
  console.log('userData:', userData);
  
  var userPracticeID = userData ? userData.practiceID : null;

  var userId = userData ? userData.userID : null;

  const sAuthToken = useSelector((state) => state.user.token);

 
 
  

  const pendingClaim = useSelector((state) => state.user.filterTableDetails);
  const rejectedCount = useSelector((state) => state.user.rejectedClaim);
  const deniedCount = useSelector((state) => state.user.deniedClaim);
  const expiredCount = useSelector((state) => state.user.expiredClaim);
  const errorCount = useSelector((state) => state.user.errorClaim);
  const closedCount = useSelector((state) => state.user.closedClaim);
  const submissionCount = useSelector((state) => state.user.submissionClaim);
  

  useEffect(() => {
    // Set default tab to PendingClaims
      document.title = 'Workable Claims'
    if (location.pathname === '/workableclaims') {
      navigate('pendingclaims');
      setActiveTab('pendingclaims');
    } else {
      // Set active tab based on the current path
      setActiveTab(location.pathname.split('/').pop());
    }
  }, [location, navigate]);




  
  
  const handleGetAllClaimsCount = async () => {


      const objClaim = {

        iPracticeID  : userPracticeID,
        sFilterText : userId

      }

    
    console.log("objClaim", objClaim);
  
    var sInputJSON = JSON.stringify({objClaim:objClaim});
    console.log("inputRow of" + CommonAPIConstants.GetAllWorkableClaimsCounts, sInputJSON);
   

      const url = `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.GetAllWorkableClaimsCounts}?sInputJSON=${sInputJSON}`;

      console.log("URL: ",  url);
   
      fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sAuthToken}`
        }
      })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {



        const parsedData = JSON.parse(data)
        setclaimCountData(parsedData)

        console.log("GetAllWorkableClaimsCounts of" + CommonAPIConstants.GetAllWorkableClaimsCounts, parsedData);

      

       
      })
      .catch((error) => {
        console.error('Error fetching:', error);
      });
    }
  



    useEffect(() => {

      handleGetAllClaimsCount();

    },[])



  const handlePendingClick = () => {
    navigate('pendingclaims')
  }

  const handleRejectedClick = () => {
    navigate('rejectedclaims')
  }

  const handleDeniedClick = () => {
    navigate('deniedclaims')
  }


 
  const handleExpiringClick = () => {
    navigate('expiringclaims')
  }


  const handleErrorClick = () => {
    navigate('errorclaims')
  }


  
  const handleClosedClick = () => {
    navigate('closedclaims')
  }


   
  const handleSubmissionClick = () => {
    navigate('submissionclaims')
  }



  const handleTabClick = (tab) => {
    setActiveTab(tab);
    navigate(tab);
  };



  return (
    <>
      
      <ul className="nav nav-pills mt-1 nav-style" id="pills-tab" role="tablist">
        <li className="nav-item">
          <a
            className={`nav-link p-1 tab-style ${activeTab === 'pendingclaims' ? 'active-tab' : ''}`}
            role="tab"
            aria-controls="pills-home"
            aria-selected={activeTab === 'pendingclaims'}
            onClick={() => handleTabClick('pendingclaims')}
          >
                    Pending( {claimCountData.PendingClaims == pendingClaim 
            ? claimCountData.PendingClaims || 0
            : pendingClaim || 0}
          )
          </a>
        </li>

       
        <li className="nav-item">
          <a
            className={`nav-link p-1 tab-style ${activeTab === 'rejectedclaims' ? 'active-tab' : ''}`}
            role="tab"
            aria-controls="pills-profile"
            aria-selected={activeTab === 'rejectedclaims'}
            onClick={() => handleTabClick('rejectedclaims')}
          >
           Rejected({
              claimCountData.RejectedClaims >= rejectedCount
                ? claimCountData.RejectedClaims 
                : rejectedCount || 0 
            })
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link p-1 tab-style ${activeTab === 'deniedclaims' ? 'active-tab' : ''}`}
            role="tab"
            aria-controls="pills-contact"
            aria-selected={activeTab === 'deniedclaims'}
            onClick={() => handleTabClick('deniedclaims')}
          >
            Denied({claimCountData.DeniedClaims >=deniedCount 
                ? claimCountData.DeniedClaims 
                : deniedCount || 0}
              )
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link p-1 tab-style ${activeTab === 'expiringclaims' ? 'active-tab' : ''}`}
            role="tab"
            aria-controls="pills-contact"
            aria-selected={activeTab === 'expiringclaims'}
            onClick={() => handleTabClick('expiringclaims')}
          >
            Expiring({claimCountData.ExpiringClaims >= expiredCount 
              ? claimCountData.ExpiringClaims 
              : expiredCount || 0}
            )
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link p-1 tab-style ${activeTab === 'errorclaims' ? 'active-tab' : ''}`}
            role="tab"
            aria-controls="pills-contact"
            aria-selected={activeTab === 'errorclaims'}
            onClick={() => handleTabClick('errorclaims')}
          >
            Error(
              {claimCountData.ErrorClaims >= errorCount 
                ? claimCountData.ErrorClaims || 0
                : errorCount || 0}
              )
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link p-1 tab-style ${activeTab === 'closedclaims' ? 'active-tab' : ''}`}
            role="tab"
            aria-controls="pills-contact"
            aria-selected={activeTab === 'closedclaims'}
            onClick={() => handleTabClick('closedclaims')}
          >
            Closed(
              {claimCountData.ClosedClaims >= closedCount 
                  ? claimCountData.ClosedClaims || 0
                  : closedCount || 0}
                )
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link p-1 tab-style ${activeTab === 'submissionclaims' ? 'active-tab' : ''}`}
            role="tab"
            aria-controls="pills-contact"
            aria-selected={activeTab === 'submissionclaims'}
            onClick={() => handleTabClick('submissionclaims')}
          >
            Submission Failed(
              {claimCountData.SubmissionFailedClaims >= submissionCount 
                  ? claimCountData.SubmissionFailedClaims 
                  : submissionCount || 0}
                )
          </a>
        </li>
      </ul>


      <div className="tab-content" id="pills-tabContent">
        <Routes>
          <Route path="pendingclaims" element={<PendingClaims />} />
          <Route path="rejectedclaims" element={<RejectedClaims />} />
          <Route path="deniedclaims" element={<DeniedClaims />} />
          <Route path="expiringclaims" element={<ExpiringClaims />} />
          <Route path="errorclaims" element={<ErrorClaims />} />
          <Route path="closedclaims" element={<ClosedClaims/>} />
          <Route path="submissionclaims" element={<SubmissionClaims />} />
        </Routes>
      </div>
    </>
  )
}

export default TabNavigation
